<template>
  <page>
    <b-row>
      <b-col cols="12" sm="8" offset-sm="2">
        <h1 class="mb-3">Terms and Conditions</h1>
        <ol>
          <li>eXPD8 Rewards is open for all eXPD8 colleagues to participate.</li>
          <li>The content and jobs are set up to be shared on the colleague’s personal social media pages and email, at a colleague’s own discretion.</li>
          <li>To qualify for eXPD8 rewards, colleagues must register using their email address that is logged with the company.</li>
          <li>You can only register for eXPD8 rewards once.</li>
          <li>‘Pieces of 8’ will only be rewarded as a result of actions taken on an individual’s unique link which is accessed via the share buttons on the eXPD8 rewards site or app.</li>
          <li>Jobs and content shared without using the unique link, will not be counted or rewarded as we do not have visibility of this activity.</li>
          <li>The number of ‘Pieces of 8’ you can earn by day or week is limited to ensure fair access for all colleagues. This is clearly stated on the eXPD8 Rewards site. For example, if the limit is set to 60 ‘Pieces of 8’ per week on shares, you will only be rewarded up to 60 ‘Pieces of 8’ per week, even if you share the jobs or content more times. The limit can be amended by the company at any time and my vary by individual campaigns.</li>
          <li>It is the colleague’s responsibility to redeem their ‘Piece of 8’ in order to claim their vouchers.</li>
          <li>You can only claim vouchers if you have enough ‘Pieces of 8’ for the voucher you wish to redeem.</li>
          <li>If there is deemed to be any mis-use or abuse of the system in anyway, the company reserve the right to remove the corresponding ‘Pieces of 8’ or/and disapprove the request for a voucher.</li>
          <li>If you leave the company, you can redeem your vouchers up until the day you leave. After that, you will not be able to access the system to redeem your vouchers. It is a colleague’s responsibility to ensure vouchers are redeemed before leaving.</li>
          <li>eXPD8 Rewards is launching on a trial basis initially before launching to the wider business, and will be reviewed at specific timeframes as determined by the business.</li>
          <li>The company reserves the right to modify or end the campaigns or rewards at any time and/or amend the value or amount of ‘Pieces of 8’ and make any changes at any time.</li>
          <li>eXPD8 rewards is voluntary. Colleagues are not obliged to participate in eXPD8 rewards and colleagues do so at their own discretion.</li>
          <li>The company reserve the right to remove association with any content at any time.</li>
        </ol>
      </b-col>
    </b-row>
  </page>
</template>

<script>
import Page from '@/components/Page';

export default {
  components: {
    Page,
  },
  metaInfo: {
    title: 'Terms and Conditions',
  }
};
</script>



// WEBPACK FOOTER //
// src/views/static/clients/eXPD8TandCs.vue